import { makeVar } from '@apollo/client'

/** True once the Privy SDK is mounted and the session bridge is registered. */
export const isPrivyReadyVar = makeVar(false)

/** True while Privy tokens are being exchanged for the XYRO session. */
export const isPrivyExchangingVar = makeVar(false)

/** Opens the nickname dialog when `signInPrivy` answers USERNAME_REQUIRED. */
export const isPrivyUsernameDialogOpenVar = makeVar(false)
